import { render } from "./RatingCircle.vue?vue&type=template&id=5baff320&scoped=true"
import script from "./RatingCircle.vue?vue&type=script&lang=js"
export * from "./RatingCircle.vue?vue&type=script&lang=js"

import "./RatingCircle.vue?vue&type=style&index=0&id=5baff320&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5baff320"]])

export default __exports__